function effectiveStartMs(allocation) {
  const start = new Date(allocation.start_at).getTime();
  return start - (Number(allocation.buffer_before_min) || 0) * 60 * 1000;
}

function effectiveEndMs(allocation) {
  const end = new Date(allocation.end_at).getTime();
  return end + (Number(allocation.buffer_after_min) || 0) * 60 * 1000;
}

export function allocationsOverlap(a, b) {
  if (!a?.resource_id || a.resource_id !== b?.resource_id) return false;
  if (a.id && b.id && a.id === b.id) return false;
  return (
    effectiveStartMs(a) < effectiveEndMs(b) &&
    effectiveStartMs(b) < effectiveEndMs(a)
  );
}

export function overlappingAllocationIds(allocations) {
  const ids = new Set();
  const slots = allocations || [];

  for (let i = 0; i < slots.length; i += 1) {
    for (let j = i + 1; j < slots.length; j += 1) {
      if (allocationsOverlap(slots[i], slots[j])) {
        ids.add(slots[i].id);
        ids.add(slots[j].id);
      }
    }
  }

  return ids;
}

export function findOverlappingSibling(allocation, siblings) {
  if (!allocation) return null;
  return (
    (siblings || []).find(other => allocationsOverlap(allocation, other)) ||
    null
  );
}

export function findAllocationById(allocations, id) {
  if (!id) return null;

  const stack = [...(allocations || [])];
  while (stack.length) {
    const alloc = stack.pop();
    if (alloc) {
      if (alloc.id === id) return alloc;
      if (alloc.sub_allocations?.length) {
        stack.push(...alloc.sub_allocations);
      }
    }
  }

  return null;
}

export function extractConflictingAllocationId(reason) {
  if (!reason) return null;
  const match = reason.match(
    /Conflicts with allocation ([a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12})/i
  );
  return match ? match[1] : null;
}

export function isOverlapInvalidReason(reason) {
  if (!reason) return false;
  return (
    /time_overlap/i.test(reason) ||
    /Conflicts with allocation/i.test(reason) ||
    /Conflicts detected:/i.test(reason)
  );
}

export function isSlotOverlapInvalid(allocation, siblings) {
  if (allocation?.status !== 'invalid') return false;
  if (!isOverlapInvalidReason(allocation.invalid_reason)) return false;

  const conflictId = extractConflictingAllocationId(allocation.invalid_reason);
  const siblingIds = new Set(
    (siblings || []).map(slot => slot.id).filter(Boolean)
  );
  // Same-event sibling overlaps are allowed by availability; ignore stale refs.
  if (conflictId && siblingIds.has(conflictId)) {
    return false;
  }

  return true;
}

export function isSlotInvalid(allocation, siblings) {
  if (isSlotOverlapInvalid(allocation, siblings)) return true;
  if (allocation?.status !== 'invalid') return false;
  return !isOverlapInvalidReason(allocation.invalid_reason);
}
